import React, { Dispatch, SetStateAction, useState } from "react";
import { Product } from "../../../../context/product-context/product";
import "../../../../ui/widgets/dialog/styles.scss";
import CancelCardholderApplication from "./cancel-cardholder-application";
import CancelBasicAccountApplication from "./cancel-basic-account-application";
import ApplicationCanceledDialog from "./application-canceled";
import { CancelReasonModel } from "./types";
import { CancellationCase } from "../../../../context/cancelApplicationContext";

function CancelDialog({
  cancellationCase,
  setCancelDialogActive,
  cancelApplicationCallback,
  switchProductCallback,
  isCardCancellation,
}: {
  cancellationCase: CancellationCase;
  setCancelDialogActive: Dispatch<SetStateAction<boolean>>;
  cancelApplicationCallback: (values: CancelReasonModel) => void;
  switchProductCallback: (product: Product) => void;
  isCardCancellation: boolean;
}): React.JSX.Element {
  const [cancelConfirmationShown, setCancelConfirmationShown] =
    useState<boolean>(false);
  if (cancelConfirmationShown) {
    return (
      <ApplicationCanceledDialog
        onDismiss={() => {
          setCancelConfirmationShown(false);
          setCancelDialogActive(false);
          window.location.reload();
        }}
      />
    );
  }

  const onCancel = (values: CancelReasonModel): void => {
    cancelApplicationCallback(values);
    setCancelConfirmationShown(true);
  };

  if (isCardCancellation) {
    return (
      <CancelCardholderApplication
        cancellationCase={cancellationCase}
        setCancelDialogActive={setCancelDialogActive}
        cancelApplicationCallback={onCancel}
      />
    );
  } else {
    return (
      <CancelBasicAccountApplication
        cancellationCase={cancellationCase}
        setCancelDialogActive={setCancelDialogActive}
        cancelApplicationCallback={onCancel}
        switchProductCallback={switchProductCallback}
      />
    );
  }
}

export default CancelDialog;
